import { FormattedMessage } from "react-intl"

import SBEditable from "../../../components/sbEditable/sbEditable"
import { ArticlePanelOptionsToClasses } from "../articlePanelHelpers"
import { FileToAudioMIMEType } from "../../../helpers/MIMEHelpers"

function Html5AudioEmbed({ blok }) {
  const showControls = blok.showcontrols === "yes" ? true : null
  
  return (
    <SBEditable blok={blok} withClass={ArticlePanelOptionsToClasses(blok)}>
      <div className={`div-align-${blok.alignment || "left"}`} style={{maxWidth: blok.maxwidth ? `${blok.maxwidth}px` : 520}}>
        <audio controls={showControls} style={{width: "100%"}}>
          {blok.sources.map((sourceBlok)=>(
            <AudioSource key={sourceBlok._uid} source={sourceBlok.source} url={sourceBlok.url} />
          ))}
          <p>
            <FormattedMessage id="component.articlepanels.html5audioembed.unsupported_message" />
          </p>
        </audio>
      </div>
    </SBEditable>
  )
}

function AudioSource({ source, url }) {
  let audioSrc = "";
  if (source && source.filename) {
    audioSrc = source.filename;
  } else if (url) {
    audioSrc = url;
  }
  return <source src={audioSrc} type={FileToAudioMIMEType(audioSrc)} />;
}

export default Html5AudioEmbed